// Port of api/fuel/app/classes/filter/search/games/filters/query/game/age/community.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.age.community',
	priority: 49,
	require: function(config, filter) {
		return rangeActive(filter.age && filter.age.community, 2, 21)
	},
	run: function(config, filter, data, query) {
		query.where('g.game_age_community', '>=', filter.age.community.from)
		query.where('g.game_age_community', '<=', filter.age.community.to)
	}
}
